<div class="not-found">
    <div class="icon-col">
        <img class="icon" src="/assets/images/onion-error.png" height="208" width="205">
    </div>

    <div class="details-col">
        <div class="block">
            <h1><span class="error-code">404</span> Page not found</h1>
            <h2>The page you are looking for does not exist. Here are some suggestions of possible causes.</h2>
        </div>

        <div class="block">
            <h2>We have changed the URL of the document.</h2>
            <p>Your request will appear in our logs together with the information from which <a [href]="referrerHelpUrl"
                    target="_blank">page you are coming from</a>. We regularly review those logs and we will update the
                origin if possible.</p>
        </div>

        <div *ngIf="!isStaff" class="block">
            <h2>You try to open a page which requires and &#64;kaptio.com email address.</h2>
            <p>In this case, you can <a (click)="login()">login here with your Kaptio account</a>, and view this page
                afterwards.</p>
        </div>

        <div class="block">
            <h2>You have entered an invalid URL in your browser.</h2>
            <p>We are very sorry that we cannot deliver the page you are looking for. Maybe our <a
                    [routerLink]="defaultRoute">overview page</a> helps you to find the right information.</p>
        </div>
    </div>
</div>